module.exports = __webpack_public_path__ + "static/media/496.119ff83a.png";